const taggingHelper = (type, index, id, labelType) => {
    let TGGEventLabel;
  
    if (labelType === "type1") {
      TGGEventLabel = `${type}, Position:${index}, SliderID:${id}`;
    } else if (labelType === "type2") {
      TGGEventLabel = `${type}, SliderID:${id}`;
    }
  
    window.dataLayer.push({
      event: "white_tiles_slider",
      TGGEventCategory: "White Tiles Panel",
      TGGEventAction: "Tiles Interaction",
      TGGEventLabel
    });
  };
  
  export default taggingHelper;





  